import React from 'react';
import PropTypes from 'prop-types';
import { ButtonTag } from './styles';

const Button = ({ children, onClick, htmlType, theme, disabled, styles, as }) => (
  <ButtonTag type={htmlType} onClick={onClick} btnType={theme} disabled={disabled} styles={styles} as={as || 'button'}>
    {children}
  </ButtonTag>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  htmlType: PropTypes.oneOf(['button', 'submit']),
  theme: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  disabled: PropTypes.bool,
  styles: PropTypes.instanceOf(Object),
  as: PropTypes.string,
};

export default Button;
